document.addEventListener("DOMContentLoaded", function () {
  const video = document.querySelector("#what-is-pc-video");
  const videoSource = video.querySelector("source");
  function startObserving() {
    if ("IntersectionObserver" in window) {
      const videoObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            videoSource.src = videoSource.dataset.src;
            video.load();
            video.muted = true; // Ensure video is muted
            video.play();
            observer.unobserve(video); // Stop observing after playing
          }
        });
      });

      videoObserver.observe(video);
    } else {
      // Fallback for browsers that don't support IntersectionObserver
      videoSource.src = videoSource.dataset.src;
      video.load();
      video.muted = true;
      video.play();
    }
  }

  function handleScroll() {
    startObserving(); // Start observing immediately after first scroll
    window.removeEventListener("scroll", handleScroll); // Remove listener after first scroll
  }

  window.addEventListener("scroll", handleScroll);
});
